import { OrderDocumentType } from '@/types/index';

export interface IMilestoneSelected {
  _id: string;
  paymentDate: string;
  total: number;
  status: string;
  subscription?: { _id: string; organization?: string };
  billingOrders?: { _id: string; number: number }[];
  orderItem: {
    subscriptionId?: string;
    product?: { name: string };
    sku?: { name: string };
    plan?: { name: string; code?: string };
    orderItemType: string;
    order?: { number: number };
  };
}

export interface IMonthlyData {
  _id: string;
  milestones: IMilestoneSelected[];
}

export interface IBillingFilters {
  search: string;
  year: number[];
  month: number[];
  status: string[];
}

export const DEFAULT_BILLING_FILTERS: IBillingFilters = {
  search: '',
  year: [],
  month: [],
  status: [],
};

interface BillingOrderDocumentFile {
  name: string;
  url: string;
  size: number;
}

export interface BillingOrderDocument {
  _id: string;
  documentType: OrderDocumentType;
  number?: string;
  description?: string;
  documentDate?: string | Date;
  file?: BillingOrderDocumentFile;
  amount?: number;
  organization?: string;
  createdAt?: string | Date;
  updatedAt?: string | Date;
}

export const MILESTONES_PER_PAGE = 3;

export function sortMonthlyDataByDate(monthlyData: IMonthlyData[]): IMonthlyData[] {
  return [...monthlyData].sort((a, b) => {
    if (typeof a._id !== 'string' || typeof b._id !== 'string') {
      return 0;
    }
    return a._id.localeCompare(b._id);
  });
}
